import React from "react";
import DonutChart from "./DonutChart";

// A single-value circular gauge — reuses DonutChart's ring rendering with a
// transparent "remainder" segment, plus a centered label overlay.
export default function Gauge({ pct, color, size = 160, strokeWidth = 16, centerLabel, centerSubLabel }) {
  return (
    <div className="relative mx-auto flex items-center justify-center" style={{ width: size, height: size }}>
      <DonutChart
        segments={[
          { value: pct, color },
          { value: Math.max(0.0001, 1 - pct), color: "transparent" }
        ]}
        size={size}
        strokeWidth={strokeWidth}
      />
      <div className="absolute flex flex-col items-center">
        <span className="text-3xl font-bold text-[#202124] dark:text-[#e8eaed]">{centerLabel}</span>
        {centerSubLabel && <span className="text-[10px] text-[#9aa0a6] uppercase tracking-wide text-center px-2">{centerSubLabel}</span>}
      </div>
    </div>
  );
}
